import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/onix/Seo";
import { ShieldMark } from "../components/onix/ShieldMark";
import { useLang } from "../i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  const tn = t.notfound;
  return (
    <main className="pt-[76px]">
      <Seo title={tn.seoTitle} description={tn.seoDesc} path="/404" />
      <section data-testid="not-found" className="onix-shell min-h-[70vh] flex flex-col items-center justify-center text-center py-24">
        <ShieldMark variant="white" className="w-[160px] md:w-[200px] mb-10" alt="Escudo ONIX" />
        <p className="tech-label mb-4">{tn.tag}</p>
        <h1 className="text-4xl sm:text-5xl font-bold font-serif text-onix-white mb-6">{tn.h1}</h1>
        <p className="text-base text-onix-silver max-w-md mb-10">{tn.text}</p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link data-testid="notfound-home" to="/" className="btn-onix-primary">
            {tn.home}
            <ArrowRight size={14} aria-hidden="true" />
          </Link>
          <Link data-testid="notfound-eco" to="/ecosistema" className="btn-onix-secondary">
            {tn.eco}
          </Link>
        </div>
      </section>
    </main>
  );
}
